
// => Styling
import styles from './CardInspect.module.css';

// => Utils
import { findClipById } from '../../../util/Utils';

// => Data
import cards from '../../../content/cards.json';
import { boosterPacks } from '../../../content/boosterPacks';
import baseClips from '../../../content/baseClips.json';

// => React
import { useState, useEffect, useRef } from 'react';


// ============
// Component
// ============
const CardInspect = ({
    data = cards.test[0],
    index = 0,
    set = boosterPacks[0].id,
    defaultScale = 1.0,
    hoverScale = 1.1,
    showTags = true,
}) => {

    const cardRef = useRef(null)
    const vidRef = useRef(null)
    const glareRef = useRef(null)

    const [showPlayError, setShowPlayError] = useState(false)

    useEffect(() => {
        if (cardRef.current) {
            cardRef.current.style.scale = defaultScale
        }
        const glare = glareRef.current
        if (glare) {
            glare.style.setProperty('--pointer-x', 230 + "px")
            glare.style.setProperty('--pointer-y', 40 + "px")
            glare.style.setProperty('--opacity', .7)
        }
    })

    const mapValues = (val, minA, maxA, minB, maxB) => {
        return minB + ((val - minA) * (maxB - minB)) / (maxA - minA)
    }

    /* Input callbacks */
    const mouseEnter = (e) => {
        var isPlaying = vidRef.currentTime > 0 && !vidRef.current.paused && !vidRef.current.ended
            && vidRef.current.readyState > vidRef.current.HAVE_CURRENT_DATA;

        if (!isPlaying/* && vidRef.current.readyState > vidRef.current.HAVE_CURRENT_DATA*/) {
            vidRef.current.play()
            .then(() => {
                setShowPlayError(false)
            })
            .catch((err) => {
                setShowPlayError(true)
                console.error(err)
            })
            //setShowPlayError(false)
        } /*else {
            if (vidRef.current.readyState < vidRef.current.HAVE_CURRENT_DATA) {
                setShowPlayError(true)
            }
        }*/

        cardRef.current.style.scale = hoverScale
    }

    const mouseLeave = (e) => {
        vidRef.current.currentTime = 0
        vidRef.current.pause()

        let card = cardRef.current
        let glare = glareRef.current

        card.style.transform = 'rotateX(0deg) rotateY(0deg)'
        card.style.filter = 'brightness(1)'
        card.style.scale = defaultScale

        glare.style.setProperty('--pointer-x', 230 + "px")
        glare.style.setProperty('--pointer-y', 40 + "px")
        glare.style.setProperty('--opacity', .7)
    }

    const mouseMove = (e) => {
        let card = cardRef.current
        let glare = glareRef.current

        let cardRect = card.getBoundingClientRect()

        let mouseX = e.offsetX
        let mouseY = e.offsetY
        
        let rotateY = mapValues(mouseX, 10, 250, -25, 25)
        let rotateX = mapValues(mouseY, 10, 370, 30, -30)
        let brightness = mapValues(mouseY, 10, 370, 1.3, 0.7)
        let glareOpacity = mapValues(mouseY, 10, 370, 0.4, 1.0)
        let glareX = mapValues(mouseX, 10, 250, 250, 10)
        let glareY = mapValues(mouseY, 10, 370, 370, 10)

        card.style.transform = `rotateX(${rotateX}deg) rotateY(${rotateY}deg)`
        card.style.filter = `brightness(${brightness})`
        card.style.scale = hoverScale

        glare.style.setProperty('--pointer-x', glareX + "px")
        glare.style.setProperty('--pointer-y', glareY + "px")
        glare.style.setProperty('--opacity', glareOpacity)
    }


    const getRarityText = () => {
        return data.rarity > 0 ? "RARE" : "Common"
    }

    /*const getClip = (id) => {
        // Combine base clips to search for
        let all = baseClips.babes.concat(baseClips.cocks, baseClips.shots)
        // TODO: combine set clips!

        // Return the clip we're looking for
        return all.find((c) => c.id === id)
    }*/
    const getClipSrc = (id) => {
        // Find the clip
        let clip = findClipById(id)
        // Construct clip URL
        let result = clip.path + clip.file
        return result
    }

    const getClipThumb = (id) => {
        // Find the clip
        let clip = findClipById(id)
        // Return the thumbnail URL
        return clip.thumb
    }

    const getClipTags = (id) => {
        // Find the clip
        let clip = findClipById(id)
        // Return the tags array
        return clip.tags
    }

    const getCardNum = () => {
        return (index+1).toString().padStart(3, '0')
    }

    const getSet = (id) => {
        return boosterPacks.find((s) => s.id === id)
    }

    const getSetName = (id) => {
        let set = getSet(id)
        return set.name
    }

    const getTags = () => {
        let result = ""
        let tags = getClipTags(data.clip)
        for (let i = 0; i < tags.length; i++) {
            result += tags[i]
            if (i < (tags.length-1)) {
                result += ", "
            }
        }
        if (tags.length < 1) {
            result = "none"
        }

        
        return result
    }


    // RENDER
    // ---------
    return(
        <div className={styles.container}
            onMouseEnter={(e)=>mouseEnter(e)}
            onMouseLeave={(e)=>mouseLeave(e.nativeEvent)}
            onMouseMove={(e)=>mouseMove(e.nativeEvent)}
            onClick={(e)=>e.stopPropagation()}>

            <div className={styles.card}
                ref={cardRef}>
                
                <div className={styles.inner}>
                    <video className={styles.vid}
                            poster={getClipThumb(data.clip)}
                            src={getClipSrc(data.clip)}
                            loop muted playsInline ref={vidRef} />
                    <div className={styles.cardIndex}>{getCardNum()}</div>
                </div>

                {/* BOTTOM INFO */}
                <div className={styles.bottomInfo}>
                    <span><b>Set:</b> {getSetName(set)}</span>
                    <span className={[styles.rarityLabel, data.rarity > 0 ? styles.rarityLabelRare : null].join(" ")}>{getRarityText()}</span>
                </div>

                {/* RARE FX */}
                {(data.rarity > 0) && <>
                    <div className={styles.fxRareExtra} />
                    <div className={styles.fxRareColor} />
                    <div className={styles.fxRarePattern} />
                </>}
                {(data.rarity > 0) && <></>}

                {/* FX */}
                <div className={styles.fxCommon} />
                <div className={styles.glare} ref={glareRef} />

            </div>

            {showPlayError && <span style={{zIndex: 200, bottom: '-2em', position: 'absolute', color: 'red', fontSize: '8pt', fontWeight: 'bolder'}}><b>Error:</b> Could not play video source. This is likely a codec issue.</span>}
            {showTags && <span style={{zIndex: 200, bottom: '-2em', position: 'absolute', fontSize: '10pt'}}><b>Content tags:</b> {getTags()}</span>}

        </div>
    );
}


export default CardInspect